var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header-1",
    transform: "translate(-135.000000, -59.000000)",
    fill: "#917E6A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(135.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2773377,33.3216116 L31.9238453,27.983716 C30.0118836,26.0773247 26.7615489,26.8399557 25.9967643,29.3181899 C25.4231758,31.0340165 23.5112142,31.9872121 21.7904488,31.6058594 C17.9665256,30.6526638 12.8042292,25.6960465 11.8482484,21.6926248 C11.2746599,19.9767982 12.4218369,18.0704069 14.1426023,17.498564 C16.6281524,16.7360075 17.3929371,13.4951423 15.4809755,11.588751 L10.127483,6.25085542 C8.5979137,4.91638153 6.30355978,4.91638153 4.96518666,6.25085542 L1.33245961,9.87299885 C-2.30026743,13.6857814 1.71485193,23.7896552 10.7010715,32.7496942 C19.687291,41.7097332 29.8206875,45.9038685 33.6446107,42.0910114 L37.2773377,38.468868 C38.6157855,36.943755 38.6157855,34.6560855 37.2773377,33.3216116 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.svg";
export { ForwardRef as ReactComponent };